import './CarrierDetail.less';

import { Descriptions, Space, Typography } from 'antd';
import React, { useEffect, useMemo } from 'react';
import { PatternFormat } from 'react-number-format';

import Container from '../common/Container';
import EditButton from '../common/EditButton';
import CarrierModal from '../modals/CarrierModal';

/*
interface IProps {
  id: string;
  carrier: Carrier;
  showEditModal: boolean;
  onClose: () => void;
  onUpdate: (carrier: Carrier) => void;
  updateMutation: any;
  onEditClick?: () => void;
  onHeaderActions?: (actions: ReactNode) => void;
}
*/

const CarrierDetail = ({
  carrier,
  id,
  onClose,
  onEditClick,
  onHeaderActions,
  onUpdate,
  showEditModal,
  updateMutation,
}) => {
  const headerActions = useMemo(
    () => (
      <EditButton
        ghost
        style={{ width: 120 }}
        type="primary"
        onClick={onEditClick}
      >
        Edit Profile
      </EditButton>
    ),
    [onEditClick]
  );

  useEffect(() => {
    if (onHeaderActions) {
      onHeaderActions(headerActions);
    }
  }, [headerActions, onHeaderActions]);
  return (
    <Container id={id}>
      <Space direction="vertical" size="middle">
        <Descriptions
          colon={false}
          column={4}
          layout="vertical"
        >
          <Descriptions.Item
            contentStyle={{ flexDirection: 'column' }}
            label="Address"
          >
            <Typography.Text>{carrier.address1}</Typography.Text>
            {carrier.address2 && (
              <>
                <Typography.Text>{carrier.address2}</Typography.Text>
              </>
            )}
            <Typography.Text>
              {carrier.city}, {carrier.state}
            </Typography.Text>
            <Typography.Text>{carrier.zipCode}</Typography.Text>
          </Descriptions.Item>

          <Descriptions.Item
            contentStyle={{ flexDirection: 'column' }}
            label="Primary Contact"
          >
            <Typography.Text>{carrier.primaryContactName}</Typography.Text>
            <Typography.Text>{carrier.primaryEmail}</Typography.Text>
            <Typography.Text>
              <PatternFormat
                displayType="text"
                format="###-###-####"
                value={carrier.primaryPhone}
              />
              {carrier.primaryExt && <> ext {carrier.primaryExt}</>}
            </Typography.Text>
          </Descriptions.Item>
          <Descriptions.Item
            contentStyle={{ flexDirection: 'column' }}
            label="Secondary Contact"
          >
            <Typography.Text>{carrier.secondaryContactName}</Typography.Text>
            <Typography.Text>{carrier.secondaryEmail}</Typography.Text>
            <Typography.Text>
              <PatternFormat
                displayType="text"
                format="###-###-####"
                value={carrier.secondaryPhone}
              />
              {carrier.secondaryExt && <> ext {carrier.secondaryExt}</>}
            </Typography.Text>
          </Descriptions.Item>
          <Descriptions.Item>&nbsp;</Descriptions.Item>
        </Descriptions>
      </Space>
      {showEditModal && (
        <CarrierModal
          error={updateMutation.error}
          selectedCarrier={carrier}
          submitting={updateMutation.isLoading}
          onClose={onClose}
          onSubmit={onUpdate}
        />
      )}
    </Container>
  );
};

export default CarrierDetail;
